import { articles } from "@/mocks/articles";

function ArticleList() {
  const list = articles.filter((a) => a.id !== "ending-deep");

  return (
    <section className="mt-12">
      <div className="mb-6 flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
          <i className="ri-article-line text-lg"></i>
        </span>
        <h3 className="font-heading text-xl font-bold text-foreground-950">更多剧情解析</h3>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {list.map((a) => (
          <article
            key={a.id}
            className="group flex overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
          >
            <div className="hidden w-40 flex-shrink-0 overflow-hidden sm:block">
              <img
                src={a.image}
                alt={a.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-col p-5">
              <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-medium text-primary-700">
                  {a.category}
                </span>
                <span>{a.date}</span>
                <span className="text-background-300">·</span>
                <span>{a.readTime}</span>
              </div>
              <h4 className="mt-3 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {a.title}
              </h4>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {a.excerpt}
              </p>
              <div className="mt-3 flex items-center justify-between">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-heart-3-line text-primary-600"></i> {a.likes}
                </span>
                <span className="text-xs text-foreground-500">#{a.tag}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ArticleList;